import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';


class FooterStaticComponent extends Component<RouteComponentProps<any>, any> {
    constructor(props) {
        super(props);

        this.RedirectToContact = this.RedirectToContact.bind(this);
    }

    public render() {
        return (
            <div className="footer-component">
                <div className="footer">
                    <h5>Znajdź Fizjoterapeutę</h5>
                    <ul className="links">
                        <a href='/Regulamin_portalu_Znajdz_Fizjoterapeute_060220.pdf' target='_blank'>Regulamin</a>
                        <Link to='/politykaprywatnosci'>Polityka prywatności</Link>
                        <a href='https://pomoc.kif.info.pl/category/znajdz-fizjoterapeute/' target='_blank'>FAQ</a>
                        <a onClick={this.RedirectToContact}>Kontakt</a>
                    </ul>
                    <div className="icon-links">
                        <div className="youtube" onClick={this.OnYoutubeClick} />
                        <div className="facebook" onClick={this.OnFacebookClick} />
                        {/*<div className="insta" />*/}
                    </div>
                    <div className="copyright">
                        Copyright © Znajdź Fizjoterapeutę 2021
                    </div>
                </div>
            </div>
        );
    }

    private RedirectToContact(evt) {
        this.props.history.push('/contact');
    }

    private OnYoutubeClick(evt) {
        window.open('https://www.youtube.com/channel/UCTebqResLO8US792jVo-kPg', '_blank');
    }

    private OnFacebookClick(evt) {
        window.open('https://www.facebook.com/znajdzfizjoterapeute/', '_blank');
    }


}

export default withRouter(FooterStaticComponent);


// WEBPACK FOOTER //
// ./src/components/Layout/FooterStatic.tsx